import React from 'react';
import { ConfigHelper } from '../../config/ConfigHelper';
import configJson from './har-search-config.json';
import { arrayToStringOrDefault, stringOrDefault } from '../../utils';
import { useMediaQuery } from 'react-responsive';
import ResultView, {
  title,
  titleContents,
  wrapperLink,
  wrapper,
  thumbnail,
  defaultThumbnail,
  attribute,
  attributeLabel,
  attributeValue,
  featuredLabel,
} from '../../components/ResultView';
import { useLayoutMode } from '../../components/Layout';
import HeBrandmarkIcon from './../../icons/HeBrandmark';
import { trackSearchResultClick } from '../../utils/dataLayer';
import { withSearch } from '@elastic/react-search-ui';

const configHelper = new ConfigHelper(configJson);

function HARSearchResultView({
  current,
  onClickLink,
  result,
  resultsPerPage,
  searchTerm,
}) {
  const isTabletUp = useMediaQuery({ query: '(min-width: 800px)' });
  const { layoutMode } = useLayoutMode();

  if (result.path === undefined) {
    return null;
  }

  const attributes = [
    {
      label: 'Designation',
      value: stringOrDefault(result.designation, undefined),
    },
    {
      label: 'List Entry number',
      value: arrayToStringOrDefault(result.listEntries, undefined),
    },
    {
      label: 'Local Planning Authority',
      value: stringOrDefault(result.localPlanningAuthority, undefined),
    },
    {
      label: 'Assessment Type',
      value: stringOrDefault(result.assessmentType, undefined),
    },
  ];

  const filteredAttributes = attributes.filter(attr => {
    if (layoutMode === 'grid') {
      return attr.label === 'List Entry Number';
    }
    return true;
  });

  const content = (
    <>
      <div className={wrapper}>
        {stringOrDefault(result.imageUrl, undefined)
          ? layoutMode === 'grid' && (
              <img
                alt=""
                className={thumbnail}
                src={`${result.imageUrl}?autorotate=true&width=${isTabletUp ? 550 : 500}&height=${isTabletUp ? 392 : 400}&mode=crop&quality=90&upscale=true`}
              />
            )
          : layoutMode === 'grid' && (
              <div className={defaultThumbnail}>
                <HeBrandmarkIcon />
              </div>
            )}
        {result.featured === true && (
          <div className={featuredLabel}>Featured result</div>
        )}
        <h2
          className={title}
          data-featured-result={result.featured === true ? '' : undefined}
        >
          <span className={titleContents}>
            {layoutMode === 'grid' ? (
              <span dangerouslySetInnerHTML={{ __html: result.name }} />
            ) : (
              <a
                dangerouslySetInnerHTML={{ __html: result.name }}
                href={
                  configHelper.getBaseURLField() +
                  result[configHelper.getUrlField()]
                }
                onClick={() => {
                  trackSearchResultClick(
                    result._meta.id,
                    result._meta.resultNumber,
                    result.name,
                    result.path,
                    current,
                    resultsPerPage,
                    searchTerm,
                  );
                  onClickLink();
                }}
              />
            )}
          </span>
        </h2>

        {stringOrDefault(result.imageUrl, undefined) &&
          !isTabletUp &&
          layoutMode === 'list' && (
            <img
              alt=""
              className={thumbnail}
              src={`${result.imageUrl}?autorotate=true&width=760&height=452&mode=crop&quality=90&upscale=false`}
            />
          )}

        {filteredAttributes
          .filter(item => item.value !== undefined)
          .map((item, index) => (
            <div className={attribute} key={index}>
              <div className={attributeLabel}>{item.label}:</div>
              <div
                className={attributeValue}
                dangerouslySetInnerHTML={{ __html: item.value }}
              />
            </div>
          ))}
      </div>

      {stringOrDefault(result.imageUrl, undefined) &&
        isTabletUp &&
        layoutMode === 'list' && (
          <img
            alt=""
            className={thumbnail}
            src={`${result.imageUrl}?autorotate=true&width=400&height=400&mode=crop&quality=90&upscale=false`}
          />
        )}
    </>
  );

  if (layoutMode === 'grid') {
    return (
      <ResultView>
        <a
          className={wrapperLink}
          href={
            configHelper.getBaseURLField() + result[configHelper.getUrlField()]
          }
          onClick={() => {
            trackSearchResultClick(
              result._meta.id,
              result._meta.resultNumber,
              result.name,
              result.path,
              current,
              resultsPerPage,
              searchTerm,
            );
            onClickLink();
          }}
        >
          {content}
        </a>
      </ResultView>
    );
  }

  return <ResultView>{content}</ResultView>;
}

export default withSearch(({ current, resultsPerPage, searchTerm }) => ({
  current,
  resultsPerPage,
  searchTerm,
}))(HARSearchResultView);
